import { GLOBAL_SHORTCUTS, PLAYER_SHORTCUTS } from '../hooks/useKeyboardShortcuts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  context?: 'global' | 'player' | 'browse';
}

export function KeyboardShortcutsModal({ isOpen, onClose, context = 'global' }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-[#1a1a1a] rounded-xl p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Keyboard Shortcuts</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
        </div>

        <div className="space-y-4">
          <div>
            <h3 className="text-sm text-gray-400 mb-2">Global</h3>
            <div className="space-y-1">
              {Object.entries(GLOBAL_SHORTCUTS).map(([key, desc]) => (
                <div key={key} className="flex justify-between text-sm">
                  <span className="text-gray-300">{desc}</span>
                  <kbd className="px-2 py-0.5 bg-white/10 rounded text-xs">{key}</kbd>
                </div>
              ))}
            </div>
          </div>

          {context === 'player' && (
            <div>
              <h3 className="text-sm text-gray-400 mb-2">Player Controls</h3>
              <div className="space-y-1">
                {Object.entries(PLAYER_SHORTCUTS).map(([key, desc]) => (
                  <div key={key} className="flex justify-between text-sm">
                    <span className="text-gray-300">{desc}</span>
                    <kbd className="px-2 py-0.5 bg-white/10 rounded text-xs">{key}</kbd>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <p className="text-xs text-gray-500 mt-4">Press ? anytime to show this dialog</p>
      </div>
    </div>
  );
}
